
<!--  -->
<template>
  <div class="digitalpavilioncontainer digitaldetail pb100">
    <crumbs detail="true"/>
    <div class="container">
      <div class="card boxshadow borderradius10 clearfix">
        <div class="cardleft fl">
          <img :src="getImage(detailInfos.image)" class="cgyd_shdow"/>
        </div>
        <div class="cardright fl">
          <h3>{{detailInfos.name}}</h3>
          <dl>
            <dt>简介：</dt>
            <dd v-if="detailInfos.synopsis && detailInfos.synopsis!==undefined">{{detailInfos.synopsis}}</dd>
            <dd v-else>暂无介绍</dd>
          </dl>
        </div>
      </div>

      <div class="pavilion_detail">
        <ul class="dbtop clearfix">
          <li class="active">
            <a href="javascript:;"  @click="getstyle($event,1)" >图文介绍</a>
          </li>

          <li v-if="infoList.length>0">
            <a  @click="getstyle($event,3)" href="javascript:;">文化资讯</a>
          </li>
          <li v-if="activityList.length>0">
            <a  @click="getstyle($event,4)" href="javascript:;">相关活动</a>
          </li>
        </ul>
        <div class="dbttom boxshadow borderradius10 clearfix" id="tu">
          <div class="title"><span>图文介绍</span><i></i></div>
          <div class="tuwen" v-html="detailInfos.content">
          </div>
        </div>

        <div v-if="infoList.length>0" class="dbttom boxshadow borderradius10 clearfix" id="information">
          <div class="title">
            <span>文化资讯</span><i></i>
            <a href="javascript:;" @click="gotoinformationlist()">更多</a>
          </div>
          <ul class="ulnew clearfix">
            <li v-for="infoitem in infoList" :key="'a'+infoitem.id" @click="gotoInfor(infoitem)">
              <a href="javascript:;">
                <p>{{infoitem.title}}</p>
                <span>{{infoitem.publishDate}}</span>
              </a>
            </li>
          </ul>
        </div>
        <div v-if="activityList.length>0" class="dbttom boxshadow borderradius10 clearfix" id="appointment">
          <div class="title"><span>相关活动</span><i></i><a href="javascript:;" @click="gotoapplist()">更多</a></div>
          <ul class="ulbox clearfix">
            <li v-for="appitem in activityList" :key="appitem.id" @click="gotoapp(appitem.id,appitem.columnId)">
              <a href="javascript:;">
                <div class="imgbox">
                  <img :src="getImage(appitem.image)" />
                  <!-- <span class="label label1" v-if="appitem.status!=='undefined' && appitem.status.code === 0">{{appitem.status.description}}</span>
                  <span class="label label2" v-if="appitem.status!=='undefined' && appitem.status.code === 1">{{appitem.status.description}}</span>
                  <span class="label label3" v-if="appitem.status!=='undefined' && appitem.status.code === 2">{{appitem.status.description}}</span> -->
                </div>
                <div class="txtbox">
                  <h3>{{appitem.name}}</h3>
                  <p class="label">
                    <span class="label1" v-if="appitem.address && appitem.address !== undefined">{{appitem.address}}</span>
                    <!-- <span class="label2">告告</span> -->
                  </p>
                  <p class="date" v-if="appitem.beginTime && appitem.beginTime !== undefined">{{appitem.beginTime | gettime}}</p>
                </div>
              </a>
            </li>
          </ul>
        </div>

      </div>
      <!-- 评论 组件引入 -->
      <comment v-if="detailInfos" comment-show="isCommentshow" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
    </div>
    <right-sidebar
      @pvcount="pvcount"
      :comment-count="commentTotal"
      :comment-gotop="commentOffsettop"
      :comment-show="isCommentshow"
      :title="detailInfos.name"
      :image="getImage(detailInfos.image)"
      :url="this.$route.fullPath"
      ref="rightSidebar"></right-sidebar>
    <go-top></go-top>
  </div>
</template>

<script>
import {getBrandactivityDetail, getBrandactivityInfo, getBrandactivityActs} from '@/api/brandactivity/index'
import crumbs from '@/components/crumbs/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
export default {
  name: 'brandactivitydetail',
  components: {
    crumbs, Comment, RightSidebar, goTop
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      id: '',
      pavilion: {},
      venueList: [],
      infoList: [],
      activityList: [],
      isCommentshow: true,
      commentTotal: '',
      commentOffsettop: '',
      pv: 0,
      detailInfos: {},
      columnId: ''
    }
  },
  filters: {
    gettime (val) {
      return val.split(' ')[0]
    }
  },
  created () {
    this.id = this.$route.query.id
    this.columnId = this.$route.query.columnId
    this.getdetail()
  },
  methods: {
    commentCount (val) {
      this.commentTotal = val
    },
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    pvcount (val) {
      this.pv = val
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    async getdetail () {
      await getBrandactivityDetail(this.id).then(res => {
        console.log(res, 'resdetail')
        this.detailInfos = res.data.data
      })
      await getBrandactivityInfo({brandActivityId: this.id, columnId: this.columnId}).then(res => {
        console.log('resInfo', res)
        this.infoList = res.data.list.data.rows.slice(0, 18)
      })
      await getBrandactivityActs({brandActivityId: this.id, columnId: this.columnId}).then(res => {
        console.log('resApp', res)
        this.activityList = res.data.list.data.rows.slice(0, 3)
      })
    },

    gotoinformationlist () {
      this.$router.push({
        path: '/information',
        query: {
          columnId: this.infoList[0].columnId
        }
      })
    },
    gotoapplist () {
      this.$router.push({
        path: '/appointment',
        query: {
          columnId: this.activityList[0].columnId
        }
      })
    },
    gotoInfor (infoitem) {
      if (infoitem.link !== undefined && infoitem.link !== '') {
        window.open(infoitem.link)
      } else {
        this.$router.push({
          path: '/informationdetail',
          query: {
            columnId: infoitem.columnId,
            id: infoitem.id
          }
        })
      }
    },
    gotoapp (id, menuId) {
      this.$router.push({
        path: '/appointmentdetail',
        query: {
          columnId: menuId,
          id: id
        }
      })
    },
    scaleImg (e) {
      console.log(e)
      console.log(document.getElementById('ewm'))
      console.log(e.currentTarget)
      console.log(e.currentTarget.getBoundingClientRect())
      console.log(this.$refs.ewm)
    },
    getstyle (e, num) {
      e.currentTarget.parentNode.classList.add('active')
      let childs = e.currentTarget.parentNode.parentNode.childNodes
      for (var i = 0; i < childs.length; i++) {
        if (childs[i].nodeName === 'LI') {
          childs[i].classList.remove('active')
          console.log(childs[i].classList)
        }
      }
      e.currentTarget.parentNode.classList.add('active')
      if (num === 1) {
        document.querySelector('#tu').scrollIntoView(true)
      } else if (num === 2) {
        document.querySelector('#venue').scrollIntoView(true)
      } else if (num === 3) {
        document.querySelector('#information').scrollIntoView(true)
      } else if (num === 4) {
        document.querySelector('#appointment').scrollIntoView(true)
      }
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/digitalpavilion.scss';
/deep/ .comment{
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0,0,0,0.05);
  padding-bottom: 60px!important;
}

.cardright{
  height: 100% !important;
  dl{
    height: 100% !important;
    dd{
      max-height: 100% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/brandactivity/detail.vue